import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {ICloudflareDefaultRecordState} from "../reducers/cloudflare-default-dns-record.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getCloudflareDefaultRecordState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.cloudflareDefaultRecord);

export const getCloudflareDefaultRecord = (websiteId: number) => createSelector(getCloudflareDefaultRecordState,
  (state: ICloudflareDefaultRecordState) => (state[websiteId] && state[websiteId].dnsRecords) || null
);

export const getCloudflareDefaultRecordLoading = (websiteId: number) => createSelector(getCloudflareDefaultRecordState,
  (state: ICloudflareDefaultRecordState) =>
    state[websiteId].loading
);

export const getCloudflareDefaultRecordLoaded = (websiteId: number) => createSelector(getCloudflareDefaultRecordState,
  (state: ICloudflareDefaultRecordState) =>
    state[websiteId] ? state[websiteId].loaded : false
);
